var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningRectangleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "#CC8F03"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 10.5,
    stroke: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19437_1602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.48154 16C6.39223 16 6.31104 15.9767 6.23796 15.93C6.16489 15.8833 6.10805 15.8218 6.06745 15.7454C6.02686 15.669 6.00453 15.5862 6.00047 15.4971C5.99641 15.408 6.01874 15.321 6.06745 15.2361L10.5737 7.08796C10.6224 7.00308 10.6854 6.93942 10.7625 6.89699C10.8396 6.85455 10.9188 6.83333 11 6.83333C11.0812 6.83333 11.1604 6.85455 11.2375 6.89699C11.3146 6.93942 11.3776 7.00308 11.4263 7.08796L15.9325 15.2361C15.9813 15.321 16.0036 15.408 15.9995 15.4971C15.9955 15.5862 15.9731 15.669 15.9325 15.7454C15.8919 15.8218 15.8351 15.8833 15.762 15.93C15.689 15.9767 15.6078 16 15.5185 16H6.48154ZM7.3219 14.9815H14.6781L11 8.36111L7.3219 14.9815ZM11 14.4722C11.138 14.4722 11.2537 14.4234 11.3471 14.3258C11.4405 14.2282 11.4872 14.1072 11.4872 13.963C11.4872 13.8187 11.4405 13.6977 11.3471 13.6001C11.2537 13.5025 11.138 13.4537 11 13.4537C10.862 13.4537 10.7463 13.5025 10.6529 13.6001C10.5595 13.6977 10.5128 13.8187 10.5128 13.963C10.5128 14.1072 10.5595 14.2282 10.6529 14.3258C10.7463 14.4234 10.862 14.4722 11 14.4722ZM11 12.9444C11.138 12.9444 11.2537 12.8956 11.3471 12.798C11.4405 12.7004 11.4872 12.5795 11.4872 12.4352V10.9074C11.4872 10.7631 11.4405 10.6422 11.3471 10.5446C11.2537 10.4469 11.138 10.3981 11 10.3981C10.862 10.3981 10.7463 10.4469 10.6529 10.5446C10.5595 10.6422 10.5128 10.7631 10.5128 10.9074V12.4352C10.5128 12.5795 10.5595 12.7004 10.6529 12.798C10.7463 12.8956 10.862 12.9444 11 12.9444Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19437_1602"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningRectangleIcon);
export default __webpack_public_path__ + "static/media/warning-rectangle-icon.f35650394807021dd6e956fe6b339094.svg";
export { ForwardRef as ReactComponent };